import styled from '@emotion/styled/macro'

import Icon from '../Icon'

export const SortIcon = styled(Icon)`
  margin-left: 2px;

  &.fa-sort-down {
    margin-top: -2px;
  }

  &.fa-sort-up {
    margin-top: 4px;
  }
`
